import { GlobalReducer } from '../../app';
import { Reducer } from 'redux';
import { initialResponseState, IResponseState } from '../../state';
import { AdminCreateAccount, CreateAccountTypes, IAdminCreateAccountAction } from './createAccount.type';

export const CreateAccountReducer: Reducer<IResponseState, IAdminCreateAccountAction> = (
	state = initialResponseState,
	action: AdminCreateAccount,
) => GlobalReducer(state, action, CreateAccountTypes.ADMIN_CREATE_ACCOUNT.toString());
